import { render, staticRenderFns } from "./NewRingAuthRequest.vue?vue&type=template&id=2349d101&"
import script from "./NewRingAuthRequest.vue?vue&type=script&lang=js&"
export * from "./NewRingAuthRequest.vue?vue&type=script&lang=js&"
import style0 from "./NewRingAuthRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports